import { render, staticRenderFns } from "./bottomR1.vue?vue&type=template&id=1527c5c6&scoped=true&"
import script from "./bottomR1.vue?vue&type=script&lang=js&"
export * from "./bottomR1.vue?vue&type=script&lang=js&"
import style0 from "./bottomR1.vue?vue&type=style&index=0&id=1527c5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527c5c6",
  null
  
)

export default component.exports